import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { Creators as AllCreators } from "../../../../actions";
import { SectionTitle } from "../../../../App/Common/Styles/containers";
import { IState } from "../../../../App/reducer";
import colors from "../../../../styles/colors";
import { modifyReadSpeakerPatch, patchPayloadCreator } from "../../../course-author/helpers/patches/creators";
import { IFullCourse } from "../../../course-author/types";
import ToggleDisplay from "../../../utils/ToggleDisplay";

const Creators = (AllCreators as any).App.CourseAuthor;

const SwitchDiv = styled.div`
  .switch {
    border: 1px solid ${colors.lightgrey};
    width: 6rem;
    height: 2.6rem;
    border-radius: 1.3rem;
    cursor: pointer;
    display: inline-block;
  }

  .switch-toggle {
    border: 1px solid #999;
    box-shadow: 1px 1px 1px #ccc;
    width: 2.5rem;
    height: 2.4rem;
    left: 0;
    border-radius: 1.2rem;
    background: white;
    position: relative;
    transition: left 0.2s ease-in-out;
  }

  .switch.on {
    background: ${colors.buttonBlue};
  }

  .switch.on .switch-toggle {
    left: 3.3rem;
  }

  .switch.disabled {
    cursor: not-allowed;
  }
`;

const OnSpan = styled(ToggleDisplay)`
  position: absolute;
  color: ${colors.white};
  margin-left: 0.5rem;
`;

const OffSpan = styled(ToggleDisplay)`
  position: absolute;
  margin-left: 3rem;
  margin-top: -2.5rem;
  z-index: -1;
`;

interface ISwitchProps extends React.ComponentProps<"div"> {
  on: boolean;
  enabled: boolean;
  onClick: (event: React.MouseEvent) => void;
}

const Switch: React.SFC<ISwitchProps> = ({ on, onClick, enabled }) => {
  const classes = ["switch", on ? "on " : "", enabled ? "" : "disabled"].join(" ");

  return (
    <SwitchDiv>
      <div className={classes} onClick={onClick}>
        <OnSpan shouldDisplay={on}>On</OnSpan>
        <div className="switch-toggle" />
        <OffSpan shouldDisplay={!on}>Off</OffSpan>
      </div>
    </SwitchDiv>
  );
};

export interface IEditReadSpeakerDispatchProps {
  toggleReadSpeaker: () => void;
}

export interface IEditReadSpeakerOwnProps {
  course: IFullCourse;
  courseId: string;
  userId: string;
}

export type IEditReadSpeakerProps = IEditReadSpeakerOwnProps & IEditReadSpeakerDispatchProps;

export interface IEditReadSpeakerState {
  on: boolean;
}

export class EditReadSpeaker extends React.Component<IEditReadSpeakerProps, IEditReadSpeakerState> {
  constructor(props: IEditReadSpeakerProps) {
    super(props);
    this.state = {
      on: this.props.course.state.readSpeaker,
    };
  }

  public toggleReadSpeaker = () => {
    this.props.toggleReadSpeaker();
    this.setState({ on: !this.state.on });
  };

  public render() {
    return (
      <>
        <SectionTitle>webReader</SectionTitle>
        <Switch on={this.state.on} enabled={true} onClick={this.toggleReadSpeaker} />
      </>
    );
  }
}

export default connect<{}, IEditReadSpeakerDispatchProps, IEditReadSpeakerOwnProps, IState>(
  () => ({}),
  (dispatch, ownProps) => ({
    toggleReadSpeaker: () =>
      dispatch(
        Creators.patchCourse(
          patchPayloadCreator(ownProps.course.versionId, modifyReadSpeakerPatch(ownProps.course, ownProps.userId))
        )
      ),
  })
)(EditReadSpeaker);
